import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";
import Reveal from "../Reveal";

const STATS = [
  { value: 10000, suffix: "+", label: "videos edited", testid: "stat-videos" },
  { value: 200, suffix: "+", label: "clients", testid: "stat-clients" },
  { value: 5, suffix: "+", label: "years of experience", testid: "stat-years" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const ctrl = animate(0, value, {
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setN(Math.round(v)),
    });
    return () => ctrl.stop();
  }, [inView, value]);
  return (
    <span ref={ref}>
      {n.toLocaleString("en-IN")}
      {suffix}
    </span>
  );
};

export const StatsBand = () => (
  <section data-testid="stats-band" className="bg-black pb-20 md:pb-28">
    <div className="container-x">
      <Reveal>
        <div className="grid grid-cols-3 border-y border-white/10 divide-x divide-white/10">
          {STATS.map((s) => (
            <div key={s.label} data-testid={s.testid} className="py-8 md:py-10 px-3 md:px-8 text-center md:text-left">
              <p className="font-heading font-black tracking-tighter text-3xl sm:text-5xl lg:text-6xl text-white leading-none">
                <Counter value={s.value} suffix={s.suffix} />
              </p>
              <p className="mt-3 text-[11px] md:text-sm text-white/45 leading-snug">{s.label}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default StatsBand;
